import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const updateBookingService = async (
  bookingId: string,
  status: 'started' | 'completed',
) => {
  return await apiClient.post(`${ENDPOINTS.BOOKINGS}/update-service`, {
    bookingId,
    status,
  });
};
